import Button from '@mui/material/Button';
import PlanPaymentSuccess from './PlanPaymentSuccess';
import { STRIPE_CUSTOMER_PORTAL_LINK } from '../../../helpers/graphql/stripe';
import { useState } from 'react';
import graphQLClient from '../../../helpers/graphQLClient';
import { useIsIosApp } from '../../../helpers/appPlatform';
import dayjs from 'dayjs';
import { useSnackbar } from 'notistack';
import planName from '../../../helpers/planName';

export default function PlanCustomerPortal({
  plan,
  paymentSuccess,
  blogId,
  isCancelled,
  expiryDate,
  hostingTrialExpiryDate,
}) {
  const [checkoutClicked, setCheckoutClicked] = useState(false);
  const inIosApp = useIsIosApp();
  const { enqueueSnackbar } = useSnackbar();

  const portalFailed = () => {
    enqueueSnackbar(
      'Could not open the subscription portal — please try again.',
      { variant: 'error' },
    );
    setCheckoutClicked(false);
  };

  const getCustomerPortalLink = () => {
    setCheckoutClicked(true);
    graphQLClient(STRIPE_CUSTOMER_PORTAL_LINK, {
      blogId,
    })
      .then(res => {
        //   Redirect to checkout link
        if (res && res.stripeCustomerPortalLink) {
          const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
          if (isIOS) {
            window.open(res.stripeCustomerPortalLink, '_blank');
            // The portal opens in a new tab; this button works again.
            setCheckoutClicked(false);
          } else {
            window.location.href = res.stripeCustomerPortalLink;
          }
        } else portalFailed();
      })
      .catch(err => {
        console.error(err);
        portalFailed();
      });
  };

  return (
    <>
      {paymentSuccess && <PlanPaymentSuccess />}
      {new Date(expiryDate) > new Date() ? (
        <>
          <p>
            You are subscribed to the {planName(plan)} plan.{' '}
            {isCancelled ? (
              <>
                You have cancelled your subscription. It will end on{' '}
                {dayjs(expiryDate).format('DD/MM/YYYY')}.
              </>
            ) : (
              <>
                Your subscription renews on{' '}
                {dayjs(expiryDate).format('DD/MM/YYYY')}.
              </>
            )}
          </p>
          {plan === 'starter' && hostingTrialExpiryDate && (
            <p>
              {new Date(hostingTrialExpiryDate) > new Date() ? (
                <>
                  Your hosting trial expires on{' '}
                  {dayjs(hostingTrialExpiryDate).format('DD/MM/YYYY')}.
                </>
              ) : (
                <>
                  Your hosting trial has expired. Upgrade to Basic, Pro, or VIP
                  to continue hosting your blog.
                </>
              )}
            </p>
          )}
          {!inIosApp && (
            <p>
              To switch to a different plan or{' '}
              {isCancelled ? 'renew' : 'cancel'} your subscription, click the
              button below to open the subscription portal. You can also manage
              your billing methods and view invoices.
            </p>
          )}
        </>
      ) : (
        <p>
          Oops, looks like your hosting subscription has expired! Don&apos;t
          worry, your posts will still be accessible on TravelFeed, but in order
          to continue hosting your blog and all the amazing content you&apos;ve
          created, you&apos;ll need to renew your subscription.
          {!inIosApp &&
            ' Click the button below to open the subscription portal and keep your blog up and running!'}
        </p>
      )}

      {inIosApp ? (
        <p className="tw-text-gray-600 dark:tw-text-gray-300">
          Subscription management is not available in this app.
        </p>
      ) : (
        <Button
          color="primary"
          variant="contained"
          onClick={getCustomerPortalLink}
          disabled={checkoutClicked}
        >
          Manage your subscription
        </Button>
      )}
    </>
  );
}
